import React, { useState,useEffect } from 'react';
import moment from 'moment';

const DateRange = props => {
    const [getTo, setTo] = useState(props.to);
    const [getFrom,setFrom]=useState(props.from);
    const [getValue,setValue]=useState({
        from:'',
        to:''
    })
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    today = yyyy + '-' + mm + '-' + dd;

    const past_from = moment(today, 'YYYY-MM-DD').subtract(3, 'days').toDate();
    const past = moment(past_from).format('YYYY-MM-DD')
    const future_to = moment(new Date(), 'YYYY-MM-DD').add(3, 'days').toDate();
    const future = moment(future_to).format('YYYY-MM-DD')
    

    const handleDate = (e) => {
        const { value, name } = e.target;
        if (name === 'dateFrom') {
            setFrom(value);   
        }
        if (name === 'dateTo') {
            setTo(value);
        }
    }

    useEffect(()=>{
        validateDateRange();
    },[getTo,getFrom]);

    const validateDateRange = () => {
        //const { from, to } = state;
        const from = getFrom;
        const to= getTo;
        const a = moment(to);
        const b = moment(from);
        const diff = a.diff(b, 'days');
        if (diff >= 0) {
            props.onChange({ dateFrom: from, dateTo: to });
        }
        else {
            alert('Please select a valid date range');            
        }
    }
    if(props.archiveBox){
        return (
            <div className='my-3'>
                <div className='form-group row'>
                    <label className='col-5 col-form-label col-form-label-sm text-right'
                        htmlFor='dateFrom'>
                        From</label>
                    <div className='col-7 input-group align-items-center'>
                        <input type="date"
                            className='form-control form-control-sm rounded-0 bg-transparent text-light'                            
                            id='dateFrom'
                            aria-describedby=''
                            name='dateFrom'
                            value={props.from}
                            onChange={handleDate}
                            placeholder='from' />&nbsp;mm/dd/yyyy
                    </div>
                </div>
                <div className='form-group row'>
                    <label className='col-5 col-form-label col-form-label-sm text-right'
                        htmlFor='dateTo'>
                        To</label>
                    <div className='col-7 input-group align-items-center'>
                        <input type='date'
                            className='form-control form-control-sm rounded-0 bg-transparent text-light'                            
                            id='dateTo'
                            aria-describedby=''
                            name='dateTo'
                            min={props.from}
                            value={props.to}
                            //value={props.to}
                            onChange={handleDate}
                            placeholder='to' />&nbsp;mm/dd/yyyy
                    </div>
                </div>
            </div>
        );
    }else{

    
    return (
        <div className='my-3'>
            <div className='form-group row'>
                <label className='col-5 col-form-label col-form-label-sm text-right'
                    htmlFor='dateFrom'>
                    From</label>
                <div className='col-7 input-group align-items-center'>
                    <input type='date'
                        className='form-control form-control-sm rounded-0 bg-transparent text-light'
                        id='dateFrom'
                        aria-describedby=''
                        name='dateFrom'
                        min={past}
                        max={future}
                        defaultValue={props.from}
                        onChange={handleDate}
                        placeholder='from' />&nbsp;mm/dd/yyyy
                </div>
            </div>
            <div className='form-group row'>
                <label className='col-5 col-form-label col-form-label-sm text-right'
                    htmlFor='dateTo'>
                    To</label>
                <div className='col-7 input-group align-items-center'>
                    <input type='date'
                        className='form-control form-control-sm rounded-0 bg-transparent text-light'
                        id='dateTo'
                        aria-describedby=''
                        name='dateTo'
                        defaultValue={props.to}
                        //value={props.to}
                        min={getFrom}
                        max={future}
                        onChange={handleDate}
                        placeholder='to' />&nbsp;mm/dd/yyyy
                </div>
            </div>
        </div>
    );
    }
}

export default DateRange;
